module.exports = __webpack_public_path__ + "static/css-img-6533b2621a3fb6dffe13d504d3b12884.jpg";